import { Collection } from '@nozbe/watermelondb';

import { LocationModel, LocationPayload } from '../../../../types/Location';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareCreateLocation = ({
    payload,
    userId,
    organisationID,
    collection,
}: {
    payload: LocationPayload;
    userId: string;
    organisationID: string;
    collection: Collection<LocationModel>;
}) =>
    collection.prepareCreate((location) => {
        location.placeId = payload.placeId;
        location.name = payload.name;
        location.lat = `${payload.lat}`;
        location.lng = `${payload.lng}`;
        location.url = payload.url;
        location.utcOffset = payload.utcOffset;
        location.userId = userId;
        location.organisationId = organisationID;
    });

export const logAddLocationAction = ({
    location,
    logDBAction,
    message,
    tableName,
}: {
    location: LocationModel;
    logDBAction: DBWriterLoggerFunction;
    message: string;
    tableName: string;
}) => {
    logDBAction({
        message,
        modelName: tableName,
        payload: location,
    });
};
